



































import { Vue, Component, Prop } from 'vue-property-decorator'

import Modal from '@/components/Modal/Modal.vue'
import ModalContent from '@/components/Modal/ModalContent.vue'
import ModalHeader from '@/components/Modal/ModalHeader.vue'
import ModalFooter from '@/components/Modal/ModalFooter.vue'
import { Button } from '@alpha/ink'
import AddProject from './AddProject.vue'
import * as ui from '@/types/frontend'
import { validateProject } from '@/utilities/project-helpers'
import store from '../../store'

@Component({
  components: {
    Modal,
    ModalContent,
    ModalHeader,
    ModalFooter,
    Button,
    AddProject
  }
})
export default class AddProjectModal extends Vue {
  @Prop() readonly workspaceId!: string
  @Prop({ default: '' }) projectId!: string
  @Prop({ default: '' }) projectTitle!: string
  @Prop({ default: '' }) projectDescription!: string

  loading = false
  projectPayload = { title: this.projectTitle, description: this.projectDescription }
  titleError: string | null = null

  close () {
    this.$emit('close')
  }

  change (projectPayload: ui.ProjectPayload) {
    this.projectPayload = projectPayload
  }

  async submit () {
    this.titleError = validateProject(this.projectPayload)
    if (this.titleError) return
    this.loading = true

    const updateProjectData = {
      id: this.projectId,
      projectData: {
        title: this.projectPayload.title,
        desc: this.projectPayload.description
      }
    }

    if (this.projectId) {
      await store.dispatch.workspace.updateProject(updateProjectData)
      this.close()
    } else {
      const project = await store.dispatch.workspace.createProject({
        workspaceId: this.workspaceId,
        title: this.projectPayload.title,
        description: this.projectPayload.description
      })

      const path = `/workspaces/${this.workspaceId}/projects/${project.id}`
      this.$router.push({ path })
      this.close()
    }
  }
}
